import { ListItem, ListItemText, Theme, useMediaQuery } from '@mui/material'

type InvoiceListItemProps = {
  label: string
  value: string
}

export function InvoiceListItem({ label, value }: InvoiceListItemProps) {
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('sm'))

  return (
    <ListItem sx={{ p: 0 }}>
      <ListItemText
        primary={label}
        secondary={value}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
        primaryTypographyProps={{
          variant: isMobile ? 'body2' : 'body1',
        }}
        secondaryTypographyProps={{
          variant: isMobile ? 'body2' : 'body1',
          color: 'text.primary',
        }}
      />
    </ListItem>
  )
}
